module.exports = __webpack_public_path__ + "static/media/next.8fdd037a.svg";